import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import Select from "react-select";

import { ProgressSpinner } from "primereact/progressspinner";

const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const { checkRequiredFields } = useRequiredFields();
  const [finishedGoods, setFinishedGoods] = useState([]);
  const [productionStaff, setProductionStaff] = useState([]);
  const [selectedFinishedGoods, setSelectedFinishedGoods] = useState([]);
  const [selectedProductionStaff, setSelectedProductionStaff] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(null);

  const [unit, setUnit] = useState([]);
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const unitLoad = (selectedOption) => {
    setSelectedUnit(selectedOption);

    setInputs((values) => ({
      ...values,
      unit_id: selectedOption ? selectedOption.value : "",
    }));

    setError((prev) => ({
      ...prev,
      unit_id: null,
    }));
  };

  const unitOptions = Array.isArray(unit)
    ? unit.map((item) => ({
      ...item,
      value: item.value ?? item.id,
      label: item.label ?? item.name ?? String(item.id),
    }))
    : [];
  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        // const res = await Http.get("/product-list/finished_goods?product_group=true");
        const unitData = await Http.get("/active-unit");

        const res = await Http.get("/restaurant-finished-good");
        const production = await Http.get("/staff2?user_type=production");
        setProductionStaff(production.data);
        setFinishedGoods(res.data);
        setUnit(unitData.data);

      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const receipeLoad = (selectedOptions) => {
    const selectedItems = selectedOptions || [];
    const selectedIds = selectedItems.map((item) => item.value);

    setSelectedFinishedGoods(selectedItems);
    setInputs((values) => ({
      ...values,
      product_ids: selectedIds,
      // keep product_id for backward compatibility if backend still expects single value
      product_id: selectedIds.length > 0 ? selectedIds[0] : "",
    }));

    setError((prev) => ({
      ...prev,
      product_id: null,
      product_ids: null,
    }));
  };

  const staffLoad = (selectedOptions) => {
    const selectedItems = selectedOptions || [];
    const selectedIds = selectedItems.map((item) => item.value);

    setSelectedProductionStaff(selectedItems);
    setInputs((values) => ({
      ...values,
      staff_ids: selectedIds,
    }));

    setError((prev) => ({
      ...prev,
      staff_ids: null,
    }));
  };

  const displayError = (fieldName) => {
    if (error && error[fieldName]) {
      return <div className="text-danger small">{error[fieldName]}</div>;
    }
    return null;
  };

  const finishedGoodsOptions = Array.isArray(finishedGoods)
    ? finishedGoods.map((item) => ({
      ...item,
      value: item.value ?? item.id,
      label: item.label ?? item.name ?? String(item.id),
    }))
    : [];

  const productionStaffOptions = Array.isArray(productionStaff)
    ? productionStaff.map((item) => ({
      ...item,
      value: item.value ?? item.id,
      label: item.label ?? item.name ?? String(item.id),
    }))
    : [];

  const formSubmit = () => {
    if (checkRequiredFields()) {
      if (!inputs.product_ids || inputs.product_ids.length === 0) {
        setError((prev) => ({
          ...prev,
          product_id: "Finished Good field is required.",
        }));
        return;
      }

      Http.post("/product-group", inputs)
        .then((res) => {
          navigate("/product-group", {
            state: { message: res.data.message, type: "success" },
          });
        })
        .catch(function (e) {
          setError(e.response.data.errors);
        });
    }
  };

  return (
    <div>
      <IsLogin />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Product Group</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Create Product Group Form</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>

            {loading ? (
              <ProgressSpinner />
            ) : (
              <div>
                <div className="row">
                  <div className="col-lg">
                    <label className="font-weight-bold">
                      Name <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                      placeholder="Input Name"
                      data-required
                    />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Finished Good <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      value={selectedFinishedGoods}
                      name="product_id"
                      options={finishedGoodsOptions}
                      isMulti={true}
                      closeMenuOnSelect={false}
                      placeholder="Select Finished Goods"
                      onChange={receipeLoad}
                    />
                    {displayError("product_id")}
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Units <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      value={selectedUnit}
                      name="unit_id"
                      options={unitOptions}
                      isMulti={false}
                      closeMenuOnSelect={true}
                      placeholder="Select Unit"
                      onChange={unitLoad}
                    />

                    {displayError("unit_id")}
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Select Production <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      value={selectedProductionStaff}
                      name="staff_ids"
                      options={productionStaffOptions}
                      isMulti={true}
                      closeMenuOnSelect={false}
                      placeholder="Select Production Staff"
                      onChange={staffLoad}
                    />
                    {displayError("staff_ids")}
                  </div>
                  {/* col */}
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button className="btn btn-primary btn-block mg-b-10" onClick={formSubmit}>
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Create;
